import { Injectable } from '@angular/core';
import { isInsideEditor, updateNavigation } from '@dotcms/client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { delay, map, mergeMap, takeWhile, tap } from 'rxjs';

import { mapErrorToAction, mapToPayload } from 'ish-core/utils/operators';

import { DotCmsFacade } from '../../facades/dot-cms.facade';
import { DotCmsResourceService } from '../../services/dot-cms-resource/dot-cms-resource.service';
import { generateDotCmsRouterURI } from '../../utils/dot-cms-utils';
import { getDotCmsCommonRequestParams } from '../utils/dotcms-store-utils';

import {
  loadDotCmsHeaderNavigation,
  loadDotCmsHeaderNavigationFail,
  loadDotCmsHeaderNavigationSuccess,
  updateUVENavigation,
} from './dotcms-navigation.action';

@Injectable()
export class DotCmsNavigationEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private resourceService: DotCmsResourceService,
    private dotcmsFacade: DotCmsFacade
  ) {}

  loadDotCmsHeaderNavigation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDotCmsHeaderNavigation),
      mapToPayload(),
      getDotCmsCommonRequestParams(this.store),
      mergeMap(([payload, hostId, language]) =>
        this.resourceService.getNavigation(payload.depth, { hostId, language }).pipe(
          map(navigationItem => loadDotCmsHeaderNavigationSuccess({ navigationItem })),
          mapErrorToAction(loadDotCmsHeaderNavigationFail)
        )
      )
    )
  );

  updateNavigationUVE = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateUVENavigation),
        takeWhile(() => isInsideEditor()),
        mapToPayload(),
        tap(() => this.dotcmsFacade.destroyEditor()),
        delay(500),
        map(({ pathname }) => updateNavigation(generateDotCmsRouterURI(pathname)))
      ),
    {
      dispatch: false,
    }
  );
}
